import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { enUS, pl } from "date-fns/locale";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../components/common/PriceDisplay";
import { formatDecimalNumber } from "../../../../utils";
import { calculateAgreementPricingWithDiscount } from "../../../../services/agreementsService";
import { useLanguage } from "../../../../utils";
import AgreementBankingFormControl from "../../AgreementConfigurationDialog/Tabs/AgreementBankingFormControl";


export const AgreementDetailsTab = (props) => {
    const { agreement } = props;
    const { t } = useTranslation();
    const language = useLanguage();

    // TODO properly handle fields using placeholder
    const placeholder = "-";

    const pricing = useMemo(() => calculateAgreementPricingWithDiscount(agreement), [agreement]);
    const agreementBrokerAmount = useMemo(()=>{
        if (!pricing) return 0
        return pricing.totalListedGross * agreement.agreement_broker_percentage / 100
    }, [pricing, agreement.agreement_broker_percentage])

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={language === "pl" ? pl : enUS}
        >
            <Grid container spacing={2}>
                <Grid container item xs={6} spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            value={agreement.agreement_seller?.full_name}
                            label={t("agreements.details.caretaker")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <TextField
                            value={formatCurrency(pricing.totalListedNet)}
                            label={t("agreements.details.finalNetPrice")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <TextField
                            value={agreement.agreement_archive || placeholder}
                            label={t("agreements.details.archiveNumber")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={agreement.agreement_notarial_deed}
                            label={t("agreements.details.notarialDeedNumber")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePicker
                            value={agreement.agreement_notarial_sign_date}
                            label={t("agreements.details.notarialDeedSignDate")}
                            onChange={() => {}}
                            disabled={true}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePicker
                            value={agreement.agreement_notarial_plan_date}
                            label={t("agreements.details.plannedAgreementSignDate")}
                            onChange={() => {}}
                            disabled={true}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePicker
                            value={agreement.agreement_date_signed}
                            label={t("agreements.details.agreementSignDate")}
                            onChange={() => {}}
                            disabled={true}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePicker
                            value={agreement.agreement_date_reception}
                            label={t("agreements.details.receptionDate")}
                            onChange={() => {}}
                            disabled={true}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePicker
                            value={agreement.agreement_date_expires}
                            label={t("agreements.details.agreementExpiryDate")}
                            onChange={() => {}}
                            disabled={true}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={
                                language === "pl"
                                    ? agreement.agreement_status.status_name
                                    : agreement.agreement_status.status_name_eng
                            }
                            label={t("agreements.details.status")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={6} spacing={2}>
                    {/* <Grid item xs={12}>
                        <TextField
                            value={placeholder}
                            label={t("agreements.details.paidAmount")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid> */}
                    {/* <Grid item xs={12}>
                        <TextField
                            value={formatCurrency(pricing.totalListedGross)}
                            label={t("agreements.details.finalGrossPrice")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid> */}
                    {/* <Grid item xs={12}>
                        <TextField
                            value={placeholder}
                            label={t("agreements.details.remainingAmount")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={placeholder}
                            label={t("agreements.details.invoiceSum")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={placeholder}
                            label={t("agreements.details.remainingToFree")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <TextField
                            value={
                                agreement.agreement_is_operator ? t("common.yes") : t("common.no")
                            }
                            label={t("agreements.details.isOperator")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={
                                agreement.agreement_is_wpk ? t("common.yes") : t("common.no")
                            }
                            label={t("agreements.details.isWpk")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={
                                agreement.agreement_is_loan ? t("common.yes") : t("common.no")
                            }
                            label={t("agreements.details.isLoan")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={agreement.agreement_broker_name}
                            label={t("agreements.details.agreementBrokerName")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={`${Number(formatDecimalNumber(agreement.agreement_broker_percentage) || 0).toFixed(2)} %`}
                            label={t("agreements.details.agreementBrokerPercentage")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={formatCurrency(agreementBrokerAmount)}
                            label={t("agreements.details.agreementBrokerAmount")}
                            fullWidth
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <AgreementBankingFormControl banking={agreement.agreement_banking} readOnly={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <AgreementBankingFormControl isBankingForWithdrawal={true} banking={agreement.agreement_banking_withdrawal} readOnly={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={agreement.agreement_note_sales}
                            label={t("agreements.details.note")}
                            fullWidth
                            disabled={true}
                            multiline
                            rows={3}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </LocalizationProvider>
    );
};
